import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      // Persist to localStorage
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        localStorage.removeItem('user');
      }
    },
    setToken(state, token) {
      state.token = token;
      // Persist to localStorage
      if (token) {
        localStorage.setItem('token', token);
        // Set token in axios so it's sent automatically
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
      }
    },
    logout(state) {
      state.user = null;
      state.token = null;
      
      // Clear localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      // Remove token from axios
      delete axios.defaults.headers.common['Authorization'];
    }
  },
  actions: {
    // Initialize auth state from localStorage
    initializeAuth({ state }) {
      console.log('🔧 Store: Initializing auth from localStorage');
      console.log('🔧 Store: Token exists:', !!state.token);
      console.log('🔧 Store: User exists:', !!state.user);
      
      if (state.token) {
        // Set the token in axios headers
        axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
        console.log('🔧 Store: Set Authorization header:', `Bearer ${state.token.substring(0, 20)}...`);
      } else {
        console.log('🔧 Store: No token found, clearing Authorization header');
        delete axios.defaults.headers.common['Authorization'];
      }
    }
  }
});
